import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getLocalStorage, setLocalStorage } from 'src/functions/localStorageHandler';

interface FormResultControllerContextData {
  isSubmitted: boolean;
  isEmailSubscriptionSubmitted: () => boolean;
  setFormSubmission: () => void;
}

const FormResultController = createContext<FormResultControllerContextData>({} as FormResultControllerContextData);

const FormResultProvider: React.FC<any> = ({ children }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const isEmailSubscriptionSubmitted = useCallback(() => {
    if (getLocalStorage('formAlreadySubmitted') === 'true') {
      return true;
    }

    return isSubmitted;
  }, [isSubmitted]);

  useEffect(() => {
    const wasSubmitted = getLocalStorage('formAlreadySubmitted') === 'true';

    if (wasSubmitted) {
      setIsSubmitted(true);
    }
  }, []);

  const setFormSubmission = () => {
    setIsSubmitted(true);
    setLocalStorage('formAlreadySubmitted', 'true');
  };

  return (
    <FormResultController.Provider
      value={{
        isSubmitted,
        isEmailSubscriptionSubmitted,
        setFormSubmission,
      }}
    >
      {children}
    </FormResultController.Provider>
  );
};

const useFormResultController = (): FormResultControllerContextData => {
  const context = useContext(FormResultController);

  if (!context) {
    throw new Error('FormResultController must be used within a FormResultProvider');
  }

  return context;
};

export { useFormResultController, FormResultProvider };
